import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

import {BancosServices, PageBusquedaObject, Bancos, SatBanco} from '../bancos-services.service';
import { LoginService } from '../../../login/login.service';
import { NotificationService } from '../../../notifications/notification.service';

@Component({
  selector: 'app-formulario-bancos',
  templateUrl: './formulario-bancos.component.html',
  styleUrls: ['./formulario-bancos.component.css'],
  providers: [ NotificationService],
  preserveWhitespaces: true
})
export class FormularioBancosComponent implements OnInit {

  public id_param: number;
  bn: SatBanco[];
  errors: String[];
  public dto: any = {rfc: ''};
  busqueda: PageBusquedaObject = new PageBusquedaObject();

  tipos = [{id: 'n', titulo: 'Nacional'}, {id: 'e', titulo: 'Extranjero'}];

  constructor(private notificationService: NotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public loginService: LoginService,
    private service: BancosServices
  ) { }

  ngOnInit() {
    this.dto.tipo = 'n';
    this.dto.banco = 0;
    this.dto.gral_emp_id = this.loginService.empresa as number;

    this.busqueda.criteriaSearch = {};
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.service.getBanco(this.id_param).subscribe(response => {
          this.dto = response.contenido;
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }

  crear() {
    this.mostrarMensajeCarga();
    this.dto.gral_emp_id = this.loginService.empresa as number;
    this.dto.suc = this.loginService.sucursal as number;
    this.dto.gralUsrCrea = this.loginService.usuario.id as number;
    this.service.post(this.dto).subscribe(response => {
      this.cerrarMensajeCarga();
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/bancos']);
    }, err => {
      this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  actualizar() {
    this.mostrarMensajeCarga();
    this.dto.gral_emp_id = this.loginService.empresa as number;
    this.dto.suc = this.loginService.sucursal as number;
    this.dto.gralUsrActualiza = this.loginService.usuario.id as number;
    this.service.put(this.dto).subscribe(response => {
      this.cerrarMensajeCarga();
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/bancos']);
    }, err => {
      this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  getSatBancos() {
    this.service.getSatBancos(this.dto.titulo.toLowerCase()).subscribe(response => {
      this.bn = response;

      if (this.bn != null && this.bn.length === 1
        && this.dto.titulo === this.bn[0].nombre) {
        this.dto.banco = this.bn[0].id;
        this.dto.clave = this.bn[0].clav;
        this.dto.descripcion = this.bn[0].razon_social;
      }
    }, err => {
      console.log('este es el error', err);
    });
  }

  mostrarMensajeCarga() {
  this.notificationService.showLoadingScreen('Procesando...');
  }
  cerrarMensajeCarga() {
  this.notificationService.closeLoadingScreen();
  }

}
